import { render, staticRenderFns } from "./PaymentMethodsIndex.vue?vue&type=template&id=10a2628e&scoped=true&"
import script from "./PaymentMethodsIndex.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsIndex.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsIndex.vue?vue&type=style&index=0&id=10a2628e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2628e",
  null
  
)

export default component.exports